module.exports = __webpack_public_path__ + "static/media/7_1.942c7caa.jpg";